import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import GrooveWordLogo from 'Modules/Shared/icons/GrooveWordLogo';
import LinkedInLogo from 'Modules/SalesNavigatorConnected/components/LinkedInLogo';
import { ModifiedTheme } from 'Utils/theme/ClariTheme';

const useStyles = makeStyles((theme: ModifiedTheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: theme.palette.text.neutralColor,
    justifyContent: 'center',
  },
  mainText: {
    fontWeight: 700,
    fontSize: 36,
    color: theme.palette.text.primary,
    marginTop: 30,
  },
  closeText: {
    fontWeight: 700,
    fontSize: 18,
    color: theme.palette.text.secondary,
    marginTop: 30,
  },
  grooveLogo: {
    marginTop: 50,
  },
  divider: {
    marginTop: 102,
    width: 1072,
    opacity: 0.1,
  },
}));

const LandingPage: React.FC = () => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <LinkedInLogo />
      <Typography className={classes.mainText}>
        You&apos;ve successfully connected to LinkedIn Sales Navigator!
      </Typography>
      <Typography className={classes.closeText}>
        You can go ahead and close this tab
      </Typography>
      <hr className={classes.divider} />
      <div className={classes.grooveLogo}>
        <GrooveWordLogo />
      </div>
    </div>
  );
};

export default LandingPage;
